import { FunctionComponent } from "react";

type BikelogorectangleType = {
  logo2?: string;
  bikerider3?: string;
};

const Bikelogorectangle: FunctionComponent<BikelogorectangleType> = ({
  logo2,
  bikerider3,
}) => {
  return (
    <div className="self-stretch flex flex-row items-start justify-center [row-gap:20px] max-w-full text-left text-5xl text-gray-600 font-radley mq1350:flex-wrap mq1350:justify-center">
      <div className="w-[824.4px] flex flex-col items-start justify-start gap-[26px] min-w-[824.4px] max-w-full mq1125:min-w-full mq1350:flex-1">
        <div className="w-[606px] flex flex-row flex-wrap items-start justify-start p-2.5 box-border max-w-full">
          <img
            className="h-[100px] w-[180px] relative object-cover"
            loading="eager"
            alt=""
            src={logo2}
          />
        </div>
        <div className="self-stretch flex flex-row items-start justify-start gap-[77px] max-w-full mq800:flex-wrap mq1125:gap-[38px] mq450:gap-[19px]">
          <div className="h-[675px] w-[317px] flex flex-col items-start justify-start gap-[117px] min-w-[317px] mq800:flex-1 mq450:gap-[58px]">
            <div className="w-[248px] h-[268px] flex flex-row flex-wrap items-center justify-between p-2.5 box-border gap-[10px]">
              <div className="self-stretch w-[187px] relative flex items-center mq450:text-lgi">
                <span className="w-full">
                  <p className="m-0 text-13xl">{`Contact `}</p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">Address</p>
                  <p className="m-0">Phone Number</p>
                  <p className="m-0">Email Address</p>
                  <p className="m-0">Sales Department</p>
                  <p className="m-0">Manager</p>
                  <p className="m-0">Parts Department</p>
                </span>
              </div>
            </div>
            <div className="self-stretch flex-1 flex flex-row flex-wrap items-start justify-between p-2.5 gap-[10px] text-black">
              <div className="h-[258px] w-[282px] relative flex items-center shrink-0 mq450:text-lgi">
                <span className="w-full">
                  <p className="m-0 text-13xl">{`Direct-to-Consumer Brands `}</p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">Canyon</p>
                  <p className="m-0">YT Industries</p>
                  <p className="m-0">Commencal</p>
                  <p className="m-0">&nbsp;</p>
                </span>
              </div>
            </div>
          </div>
          <div className="flex-1 flex flex-col items-start justify-start gap-[56px] min-w-[279px] max-w-full text-black mq450:gap-[28px]">
            <div className="w-[261px] h-[318px] flex flex-row flex-wrap items-center justify-between p-2.5 box-border gap-[10px]">
              <div className="self-stretch w-[206px] relative flex items-center shrink-0 mq450:text-lgi">
                <span className="w-full">
                  <p className="m-0 text-13xl">{`Emerging & Boutique Brands `}</p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">Yeti Cycles</p>
                  <p className="m-0">Pivot Cycles</p>
                  <p className="m-0">Evil Bikes</p>
                  <p className="m-0">Norco</p>
                  <p className="m-0">Juliana</p>
                </span>
              </div>
            </div>
            <div className="self-stretch h-[278px] flex flex-row flex-wrap items-center justify-between p-2.5 box-border gap-[10px]">
              <div className="self-stretch w-[206px] relative flex items-center shrink-0 mq450:text-lgi">
                <span className="w-full">
                  <p className="m-0 text-13xl">{`Mainstream Brands `}</p>
                  <p className="m-0">&nbsp;</p>
                  <p className="m-0">Trek</p>
                  <p className="m-0">Giant</p>
                  <p className="m-0">Cannondale</p>
                  <p className="m-0">Specialized</p>
                  <p className="m-0">Santa Cruz</p>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[771px] flex flex-row flex-wrap items-end justify-center p-2.5 box-border max-w-full text-center text-black">
          <div className="h-[30px] flex-1 relative flex items-center justify-center max-w-full mq450:text-lgi">
            Copyright © MONBITATNI Mountain Bike Shop
          </div>
        </div>
      </div>
      <div className="h-[866px] w-[706px] flex flex-col items-end justify-start py-2.5 pr-5 pl-10 box-border min-w-[706px] max-w-full z-[1] ml-[-156px] mq800:min-w-full mq1350:flex-1 mq1350:ml-0">
        <img
          className="self-stretch h-[831px] relative max-w-full overflow-hidden shrink-0 object-cover mq1350:self-stretch mq1350:w-auto"
          loading="eager"
          alt=""
          src={bikerider3}
        />
      </div>
    </div>
  );
};

export default Bikelogorectangle;
